import React from 'react';
import * as mobxReact from 'mobx-react';
import { injectIntl, IntlShape } from 'react-intl';
import { CommonPopupBodyFooterLayout } from '../../../../../global/common-popup/common-popup-body-footer-layout';
import { DefaultCloseSubWindowButton } from '../../../../../global/sub-window/common/common-close-sub-window-buttons';
import DefaultButton from '../../../../../global/default-button/default-button';
import { CodeEditor } from '../../../../../global/code-editor/code-editor';
import { CustomCssFormVM } from './custom-css-form.viewmodel';
import { CUSTOM_CSS_MESSAGE, CODE_EDITOR_HEIGHT, CUSTOM_CSS_SAVING_TEXTS } from './constants/custom-css.constants';
import './custom-css-form.presentation.scss';
import {
    APPLY_AND_CLOSE_TEXT,
    APPLY_TEXT,
    CANCEL_TEXT,
} from '../../../../../../constants/common-labels.constants';

interface IProps {
    intl: IntlShape;
    vm: CustomCssFormVM;
}

const CustomCssFormPresentation = injectIntl(
    mobxReact.observer((props: IProps) => {
        const { vm, intl } = props;

        const isDisabled = vm.saving || !!vm.getCustomCssValidationError();

        return (
            <CommonPopupBodyFooterLayout
                body={
                    <>
                        <div className='oe-form'>
                            <div className='oe-form__body'>
                                <div className='code-editor-container'>
                                    <CodeEditor
                                        label={CUSTOM_CSS_MESSAGE}
                                        height={CODE_EDITOR_HEIGHT}
                                        value={vm.getCustomCss()}
                                        onChange={code => {
                                            vm.setCustomCss(code);
                                        }}
                                        validationError={vm.getCustomCssValidationError()}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }
                footer={
                    <>
                        {vm.saving && (
                            <span className='oe-popup-layout__footer-status-area'>
                                {intl.formatMessage(CUSTOM_CSS_SAVING_TEXTS)}
                            </span>
                        )}

                        <div className='buttons-block buttons-block--from-right'>
                            <DefaultCloseSubWindowButton
                                text={intl.formatMessage(APPLY_AND_CLOSE_TEXT)}
                                modifier={['fat', 'confirm-safe']}
                                onClick={() =>
                                    vm.handleSubmitCustomCssForm()
                                }
                                disabled={isDisabled}
                            />
                            <DefaultButton
                                text={intl.formatMessage(APPLY_TEXT)}
                                modifier={['fat', 'confirm-safe']}
                                onClick={() =>
                                    vm.handleSubmitCustomCssForm()
                                }
                                disabled={isDisabled}
                            />
                            <DefaultCloseSubWindowButton
                                text={intl.formatMessage(CANCEL_TEXT)}
                            />
                        </div>
                    </>
                }
            />
        );
    })
);

export { CustomCssFormPresentation };
